import GET from "./api/GET";
import POST from "./api/POST";

export const fetchInvoices = async (
  page = 1,
  limit = 10,
  search = "",
  startDate,
  endDate
) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch"
  );
  const branchId = JSON.parse(currentBranchData)?._id;
  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/invoices?branchId=${branchId}&page=${page}&limit=${limit}&search=${search}&startDate=${startDate}&endDate=${endDate}`
  );
  return response;
};

export const generateInvoice = async (credentials) => {
  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/invoice`,
    credentials,
    {
      responseType: "blob",
    }
  );
  return response;
};

export const exportInvoices = async (credentials) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch"
  );
  const branchId = JSON.parse(currentBranchData)?._id;
  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/order/export-invoices?branchId=${branchId}`,
    credentials,
    {
      responseType: "blob",
    }
  );
  return response;
};
